import React from 'react';
import PropTypes from 'prop-types';
import SchemaField from 'react-jsonschema-form/lib/components/fields/SchemaField';
import { getDefaultRegistry } from 'react-jsonschema-form/lib/utils';
import get from 'lodash.get';

const localFormRegistry = getDefaultRegistry();

class JSONSchemaInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: null
    };
  }

  _onChange = value => {
    this.setState({ value });
    if (this.props.onChange) {
      this.props.onChange(value);
    }
  };

  render() {
    const props = this.props;
    return (
      <div className="bootstrap">
        <SchemaField
          schema={{
            // type: props.type || 'string',
            title: props.label,
            // default: props.default,
            items: props.items || [],
            ...(props.schema || {})
          }}
          uiSchema={{
            ...(props.uiSchema || {})
          }}
          registry={localFormRegistry}
          formData={
            // this.state.value ||
            // get(props, 'value', get(props, 'input.value', null))
            get(props, 'input.value', null)
          }
          id="id"
          onChange={data => props.input.onChange(data)}
          disabled_onChange={this._onChange}
        />
      </div>
    );
  }
}
JSONSchemaInput.propTypes = {
  onChange: PropTypes.func,
  label: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  ),
  uiSchema: PropTypes.object
};
export default JSONSchemaInput;



// WEBPACK FOOTER //
// ./src/components/JSONSchemaInput.js